import { P360FormModel } from '@/components/dynamic-form/model/dynamic-form';
import { createAction, props } from '@ngrx/store';

export const appStoreDynamicFormActions = {
  setFormSelectedAction: createAction('DYNAMIC_FORM_SET_FORM_SELECTED', props<{ form: P360FormModel }>()),

  setAnswerFromQuestionAction: createAction(
    'DYNAMIC_FORM_SET_ANSWER_FROM_QUESTION',
    props<{ question?: number; answer?: string | Date | number | boolean }>(),
  ),

  resetFormAction: createAction('DYNAMIC_FORM_RESET_FORM', props<any>()),
};
